export function toNumber(value) {
  var number = parseFloat(value)
  return isNaN(number) ? 0 : number
}

export function roundMoney(value) {
  return Math.round(toNumber(value) * 100) / 100
}

export function roundUtility(value) {
  return Math.round(toNumber(value) * 1e8) / 1e8
}

export function purchaseCostFromList(config = {}) {
  var value = toNumber(config.priceList)
  value += toNumber(config.additional)
  value = value * (1 - toNumber(config.percentageDiscount) / 100)
  value = value * (1 - toNumber(config.percentageDiscount1) / 100)
  value = value * (1 - toNumber(config.percentageDiscount2) / 100)
  value = value * (1 + toNumber(config.additionalPercentage) / 100)
  value = value * (1 + toNumber(config.additionalPercentage1) / 100)
  value += toNumber(config.additional1)
  return roundMoney(value)
}

// Misma inversa usada al editar "Precio final" en ProductPricingEditor.
export function utilityFromSalePrice({ cost, salePrice, discount, ivaAliquot }) {
  var baseCost = toNumber(cost)
  var finalPrice = toNumber(salePrice)
  var discountBase = 1 - toNumber(discount) / 100
  var ivaFactor = 1 + toNumber(ivaAliquot) / 100

  if(baseCost <= 0 || finalPrice <= 0 || discountBase <= 0 || ivaFactor <= 0) {
    return null
  }

  return roundUtility(((finalPrice / ivaFactor / discountBase / baseCost) - 1) * 100)
}
